import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@fortawesome/fontawesome-free/css/all.css'
import { auth } from './firebase'
import { onAuthStateChanged } from 'firebase/auth'

let app

// Wait for OneSignal to be ready
window.OneSignal = window.OneSignal || [];
console.log('Setting up OneSignal...');

const initOneSignal = () => {
  if (typeof window.OneSignal === 'undefined') {
    console.log('OneSignal not loaded yet, retrying in 1s...');
    setTimeout(initOneSignal, 1000);
    return;
  }

  console.log('Initializing OneSignal...');
  window.OneSignal.push(function() {
    window.OneSignal.init({
      appId: "6e2087fa-dc23-490e-9f61-c918aa3923c6",
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: false
      },
      welcomeNotification: {
        disable: true
      }
    });
  });
};

// Start initialization
initOneSignal();

// Wait for Firebase Auth to initialize before mounting the app
onAuthStateChanged(auth, () => {
  if (!app) {
    app = createApp(App)
    app.component('QuillEditor', QuillEditor)
    app.use(router)
    app.mount('#app')
  }
})
